/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class JwksProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * get JSON Web Key Set
   * @returns any Success
   * @throws ApiError
   */
  public getApiServicesecurityWellKnownJwksJson(): CancelablePromise<{
    keys?: Array<{
      alg?: string;
      kty?: string;
      use?: string;
      x5t?: string;
      'n'?: string;
      'e'?: string;
      kid?: string;
    }>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/.well-known/jwks.json',
    });
  }

}
